const initialState = [];

const overlays = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SAVE_OVERLAYS': {
      return action.data;
    }
    default:
      return state;
  }
};

export default overlays;
